// extracted by mini-css-extract-plugin
export default {"NoEntries":"NoEntries_NoEntries__-w7cJ"};